import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const init_state = {
  data: -1,
  locations: -1,
  loading: false,
  error: null,
};

export const getPriceHistoryAsyncThunk = createAsyncThunk(
  "getPriceHistoryAsyncThunk",
  async function (canprod_id, thunkAPI) {
    try {
      const { user } = thunkAPI.extra.apiService;
      const response = await user.get(`/product/price-history/${canprod_id}`);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const priceHistorySlice = createSlice({
  name: "Price history",
  initialState: init_state,
  reducers: {
    setLocationsEmpty: (state, action) => {
      state.locations = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPriceHistoryAsyncThunk.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPriceHistoryAsyncThunk.fulfilled, (state, action) => {
        state.loading = false;
        let locations = [...Object.keys(action.payload.data)];
        state.data = action.payload.data;
        state.locations = locations;
      })
      .addCase(getPriceHistoryAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setLocationsEmpty } = priceHistorySlice.actions;

export default priceHistorySlice.reducer;
